import React from 'react';

const ROOT_CLASS =
  'group flex flex-col gap-6 rounded-card border border-border-default px-6 py-10 transition-colors hover:border-border-hover';

const TITLE_CLASS = {
  default: 'text-caption-lg text-text-primary',
  medium: 'text-caption-lg font-medium text-text-primary',
} as const;

export type ContentCardTitleEmphasis = keyof typeof TITLE_CLASS;

export interface ContentCardProps {
  href: string;
  title: string;
  excerpt: string;
  leading?: React.ReactNode;
  titleEmphasis?: ContentCardTitleEmphasis;
}

export function ContentCard({
  href,
  title,
  excerpt,
  leading,
  titleEmphasis = 'default',
}: ContentCardProps) {
  const titleClass = TITLE_CLASS[titleEmphasis];

  return (
    <a href={href} className={ROOT_CLASS}>
      {leading ? (
        <div className="flex items-center gap-2">
          {leading}
          <p className={titleClass}>{title}</p>
        </div>
      ) : (
        <p className={titleClass}>{title}</p>
      )}
      <p className="text-caption-lg text-text-tertiary">{excerpt}</p>
    </a>
  );
}

export interface ContentCardLogoLeadingProps {
  imageUrl?: string | null;
  title: string;
}

export function ContentCardLogoLeading({ imageUrl, title }: ContentCardLogoLeadingProps) {
  if (imageUrl) {
    return <img src={imageUrl} alt="" className="size-5 shrink-0" />;
  }

  return (
    <div className="flex size-5 items-center justify-center rounded-md bg-surface-frost-10">
      <span className="text-[10px] font-medium text-text-tertiary">{title.charAt(0)}</span>
    </div>
  );
}
